var jsShare = '.tools-panel[data-template="compact-in-line"] .js-share', // js-share element for 'compact-in-line' template
	jsShareList = '.tools-panel[data-template="compact-in-line"] .js-share-list', // js-share-list element for 'compact-in-line' template
	jsToolsTrigger = '.tools-panel[data-template="compact-in-line"] .js-tools-trigger', // js-tools-trigger element for 'compact-in-line' template
	$jsToolsList = $('.tools-panel[data-template="compact-in-line"] .js-tools-list'),
	$jsShare = $(jsShare),
	$jsShareList = $(jsShareList),
	$jsToolsTrigger = $(jsToolsTrigger);

// Селекторы элементов, клик по которым не закрывается панель
var	dontCollapseSelectors = [jsShare, jsToolsTrigger, '.js-add-page', '.js-del-page'];
var dontCollapseSelector = dontCollapseSelectors.join(', ');

function setDataLength() {
	var toolsLength = $jsToolsList.find('.tools-panel__item').length,
			shareLength = $jsShareList.find('.tools-panel__share-link').length;
	$jsToolsList.attr('data-length', toolsLength);
	$jsShareList.attr('data-length', shareLength);
}

function toggleToolPanel() {
	var $this = $(this);
	if ($this.hasClass('is-expand')) {
		$.Velocity($jsToolsList, 'transition.slideRightOut', 200)
			.then(function () {
				$this
					.removeClass('is-expand')
					.siblings('.js-tools-list')
					.removeClass('is-expand');
			})
			.catch(console.error);
		toogleShareList($jsShare);
	} else {
		$this
			.addClass('is-expand')
			.siblings('.js-tools-list')
			.addClass('is-expand')
			.velocity('transition.slideRightIn', 200);
	}
}

function toogleShareList(el) { // Функция принимает либо jQuery элемент $jsShare, либо this из контекста, если el не задан.
	var $this = el || $(this);
	if ($this === el || $this.hasClass('is-expand')) {
		$.Velocity($jsShareList, 'transition.slideUpOut', 200)
			.then(function () {
				$this
					.removeClass('is-expand')
					.siblings('.js-share-list')
					.removeClass('is-expand');
			})
			.catch(console.error);
	} else {
		$this
			.addClass('is-expand')
			.siblings('.js-share-list')
			.addClass('is-expand')
			.velocity('transition.slideDownIn', 200);
	}
}

//Обработка событий
$jsShare.on('click', function (event) {
	event.preventDefault();
	toogleShareList.apply(this);
});

$jsToolsTrigger.on('click', function (event) {
	event.preventDefault();
	toggleToolPanel.apply(this);
});

$(document).on('click', function (event) {
	if (!$(event.target).closest(jsShare).length) {
		$.Velocity($jsShareList, 'transition.slideUpOut', 200)
			.then(function () {
				$jsShare
					.removeClass('is-expand')
					.siblings('.js-share-list')
					.removeClass('is-expand');
			})
			.catch(console.error);
	}
	if (!$(event.target).closest(dontCollapseSelector).length) {
		$.Velocity($jsToolsList, 'transition.slideRightOut', 200)
				.then(function () {
					$jsToolsTrigger
						.removeClass('is-expand')
						.siblings('.js-tools-list')
						.removeClass('is-expand');
				})
				.catch(console.error);
	}
});

//Вызов функций
setDataLength();



/** WEBPACK FOOTER **
 ** ./frontend/components/tools-panel/compact-in-line/compact-in-line.js
 **/